import { apiUrl } from "../../api/common";
import axios from "axios";
import { LaterList, LaterListProduct } from "../../types/laterList/laterList";
import LaterListEvents from "../../events/LaterListEvents";
import { CartItemOption } from "../../types/cart/cart";

export interface AddProductToLaterListRequest {
    productId: string;
    quantity: number;
    configurable: boolean;
    selectedAddons: LaterListAddonRequest[];
}

export interface LaterListAddonRequest {
    id: string;
    selectedAddon: LaterListAddonSelectedAddon;
}

export interface LaterListAddonSelectedAddon {
    id: string;
    addonName: string;
    addonSku: string;
    selectedOptionId: string | null;
    selectedOptionName: string;
    selectedOptionPrice: number;
    selectedQuantity: number;
    selectedOption?: CartItemOption;
}

export class LaterListHandler {

    public static GetLaterList(): Promise<LaterList> {
        return new Promise<LaterList>(function (resolve, reject) {
            axios.get(apiUrl + '/laterList/', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetLaterListItemNumber(): Promise<number> {
        return new Promise<number>(function (resolve, reject) {
            axios.get(apiUrl + '/laterList/count', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetLaterListProduct(laterListProductId: string): Promise<LaterListProduct> {
        return new Promise<LaterListProduct>(function (resolve, reject) {
            axios.get(apiUrl + `/laterList/${laterListProductId}`, { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static AddProductToLaterList(data: AddProductToLaterListRequest): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(apiUrl + "/laterList", data, { withCredentials: true })
                .then((response: any) => {
                    LaterListEvents.callLaterListModifiedEvents();
                    resolve(response.data);
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }

    public static deleteProductFromLaterList(listProductId: string,): Promise<any> {
        return new Promise<any>(function (resolve, reject) {
            axios.delete(apiUrl + '/laterList/' + listProductId, { withCredentials: true }).then((response) => {
                LaterListEvents.callLaterListModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

}
